export enum FetchState {
  None = 1,
  Loading = 2,
  Loaded = 3,
  Error = 4,
  Cancel = 5,
}
